/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AuthDetailedResponse {
    getFixupPrototypeFunction() { return AuthDetailedResponse.fixupPrototype; }

    static newInstance(model: Partial<AuthDetailedResponse>): AuthDetailedResponse {
        let obj = Object.assign(new AuthDetailedResponse(), model);
        AuthDetailedResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AuthDetailedResponse>): AuthDetailedResponse {
        if (!model) return null;
        return AuthDetailedResponse.newInstance(<AuthDetailedResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AuthDetailedResponse) {
        if (!obj) return;

        models.AuthDetailedResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AuthDetailedResponse): boolean {
        Object.setPrototypeOf(obj, AuthDetailedResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.user) {
            models.UserModel.fixupPrototype(this.user);
        }
        if (this.audit) {
            models.AuditModel.fixupPrototype(this.audit);
        }
        if (this.token) {
            models.Authorization.fixupPrototype(this.token);
        }
        if (this.tenants) {
            for (let val of this.tenants) {
                models.DetailTenantModel.fixupPrototype(val);
            }
        }
    }

    /**
     * Authentication type.
     */
    auth_type: string;

    /**
     * Whether access key required.
     */
    require_access_key: boolean;

    /**
     * Account id.
     */
    account_id: string;

    /**
     * Whether account admin or not.
     */
    is_account_admin: boolean;

    /**
     * Header logo.
     */
    header_logo: string;

    /**
     * Banner logo.
     */
    banner_logo: string;

    /**
     * Token.
     */
    user: models.UserModel;

    /**
     * Authentication method.
     */
    auth_method: string;

    /**
     * Tenants list.
     */
    tenants: Array<models.DetailTenantModel>;

    /**
     * Audit details
     */
    audit: models.AuditModel;

    /**
     * Constant unit.
     */
    cost_unit: string;

    /**
     * Subscription details.
     */
    subscription_details: any;

    /**
     * Whether Product admin or not.
     */
    is_product_admin: boolean;

    /**
     * Token.
     */
    token: models.Authorization;

    /**
     * Cost currency.
     */
    cost_currency: string;

    /**
     * Footer text.
     */
    footer_text: string;

    /**
     * User Guide URL
     */
    user_guide_url: string;

    /**
     * Support URL
     */
    support_url: string;

    /**
     * Terms and Conditions URL
     */
    terms_and_conditions_url: string;

}
